module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-114x114-43041f6b6b376303483f3a3a3e8f6410.png";